export function decodeSequence(encoded: string): string[] {
    return encoded.split(';');
}

export function encodeSequence(sequence: string[]): string {
    return sequence.join(';');
}